/* eslint-disable max-statements */
import sdk from '@/sdk';
import * as store from '@/store';

import toast, {ToastType} from '@/components/Toast';
import {DocumentOperateType, DocumentUpdateData} from '@/interface';

// 快速移动到顶部/底部
export async function quickMoveToTopOrBottom(
    docGuid: string,
    goTop: boolean
) {
    try {
        const repository = store.getData(store.KEYS.CUR_REPOSITORY);
        const ksServer = await sdk.getKsServer();
        const result = await ksServer.quickMoveToTopOrBottom(docGuid, goTop);

        const docUpdateData: DocumentUpdateData = {
            action: DocumentOperateType.Move,
            parentGuid: result.parentGuid,
        };
        const docData: WizDocument = Object.assign(docUpdateData, {
            docGuid: result.docGuid,
            spaceGuid: repository.spaceGuid || '',
            groupGuid: repository.groupGuid || '',
            repositoryGuid: repository.repositoryGuid || '',
            isFromQuickMove: true, // 标记快速移动顶部/底部功能入口
        });

        // 触发目录树更新
        store.setDocumentOperate({
            docList: [docData],
            type: DocumentOperateType.Update,
            updateType: docUpdateData.action,
        });
        toast({
            type: ToastType.Success,
            content: '移动成功',
        });
        return result;
    } catch (e) {
        toast({
            type: ToastType.Error,
            content: '移动失败，请稍后重试',
        });
        return Promise.reject(e);
    }
}

/**
    * 递归查找目标文档所在的同级列表及其在其中的索引位置
    * @param list 文档树列表
    * @param targetDocGuid 目标文档的 GUID
    * @returns 包含 siblingList 和 index 的对象，找不到则 siblingList 为 null，index 为 -1
 */
export function findSiblingListAndIndex(
    list: any[],
    targetDocGuid: string
): {siblingList: any[] | null, index: number} {
    try {
        for (let i = 0; i < list?.length; i++) {
            const item = list[i];
            if (item.docGuid === targetDocGuid) {
                return {siblingList: list, index: i};
            }
            if (item.children && item.children.length > 0) {
                const res = findSiblingListAndIndex(item.children, targetDocGuid);
                if (res.siblingList) {
                    return res;
                }
            }
        }
    } catch (err) {
        console.error('findSiblingListAndIndex error', err);
    }
    return {siblingList: null, index: -1};
}

// 判断是否是列表中的第一个元素
export function isFirstItem(siblingList: any[] | null, index: number): boolean {
    return !!siblingList && index === 0;
}

// 判断是否是列表中的最后一个元素
export function isLastItem(siblingList: any[] | null, index: number): boolean {
    return !!siblingList && index === siblingList.length - 1;
}
